import { Injectable } from '@angular/core';
import { ReplaySubject }    from 'rxjs/ReplaySubject';

@Injectable()
export class DevicesConfirmedUnconfirmedService {

  // Observable
  private subject = new ReplaySubject();

  // Observable
  statusChange$ = this.subject.asObservable();

  // Service commands
  statusChange(value) {
    this.subject.next(value);
  }
}



// WEBPACK FOOTER //
// /Users/mihagresak/Documents/git-projects/vintegras-angular-new-clean/src/app/devices-confirmed-unconfirmed.service.ts